import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postNotificationsSeenAll } from "Infrastructure/Api/Api";
import { notificationsKeys } from "Api/Queries/Notifications/useNotifications";
import { newNotificationsCountKeys } from "Api/Queries/Notifications/useNewNotificationsCount";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useMarkAllNotificationsAsSeen = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      postNotificationsSeenAll(),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationsKeys.all });
      queryClient.invalidateQueries({
        queryKey: newNotificationsCountKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
